import { ARGON2_PARAMS, pbkdf2Kdf, type PasswordKdf } from "@limeshare/lsc1";

/**
 * Argon2id KDF (§2, §7.3) via hash-wasm with automatic WebCrypto PBKDF2 fallback if WASM is disabled.
 * Parameters: m = 64 MiB, t = 3, p = 1, 32-byte output. NFC-normalized.
 */
export const argon2idKdf: PasswordKdf = async (password, salt) => {
  try {
    const { argon2id } = await import("hash-wasm");
    const out = await argon2id({
      password: password.normalize("NFC"),
      salt,
      parallelism: ARGON2_PARAMS.parallelism,
      iterations: ARGON2_PARAMS.iterations,
      memorySize: ARGON2_PARAMS.memoryKiB,
      hashLength: ARGON2_PARAMS.hashLength,
      outputType: "binary",
    });
    return out instanceof Uint8Array ? out : new Uint8Array(out as ArrayBufferLike);
  } catch (err) {
    // Graceful fallback to native WebCrypto PBKDF2 (zero WebAssembly dependency)
    return pbkdf2Kdf(password, salt);
  }
};
